import Vue from 'vue';
import Vuex from 'vuex';
import http from '@/http';
import { getActiveAccount } from '@/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    account: getActiveAccount(),
    notification: {
      isVisible: false,
      text: '',
      color: '',
    },
    studentCursus: [],
    teacherCursus: [],
    cursusAreLoading: false,
  },

  getters: {
    isAuth: (state) => !!state.account,

    user: (state) => ({
      groups: state.account?.idTokenClaims.groups || [],
      name: state.account?.name || '',
      username: state.account?.username || '',
    }),
  },

  mutations: {
    SET_NOTIFICATION(state, data) {
      state.notification = data;
    },

    SET_CURSUS_LOADING(state, value) {
      state.cursusAreLoading = value;
    },

    SET_CURSUS(state, data) {
      state.studentCursus = data.studentCursus;
      state.teacherCursus = data.teacherCursus;
    },

    UPDATE_TEACHER_CURSUS(state, data) {
      const index = state.teacherCursus.indexOf(data.oldCursus);
      state.teacherCursus.splice(index, 1);
      state.teacherCursus.push(data.newCursus);
    },
  },

  actions: {
    async getCursus({ commit }) {
      commit('SET_CURSUS_LOADING', true);
      try {
        const response = await http.get('user/data_user.php');
        commit('SET_CURSUS', {
          teacherCursus: response.data.teacher,
          studentCursus: response.data.student,
        });
      } catch (error) {
        console.log(error);
      } finally {
        commit('SET_CURSUS_LOADING', false);
      }
    },
  },
});
